import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export default function NewsroomScreenAddeditRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.NewsroomScreenAddedit', {
		url: '/newsroom/screens/:id',
		controllerAs: 'vm',
		controller: NewsroomScreenAddeditCtrl,
		templateUrl: '/ng/hub/Newsroom/Screen/Addedit/NewsroomScreenAddeditCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Newsroom/Screen/Addedit/NewsroomScreenAddeditCtrl.css'),
			$title: () => 'Edit Newsroom Screen',
			screen: (Api, $stateParams) => {
				'ngInject';
				return Api.get(`/newsrooms/screens/${$stateParams.id}`).then(screen => {
					if (screen) {
						return screen;
					}
					window.location.href = '#/newsroom/screens';
				});
			},
			elements: (screen, Api) => {
				'ngInject';
				return Api.get('/newsrooms/elements/' + screen.type);
			},
			defaultColorScheme: ApiResourcify.endpoint('/newsrooms/color_schemes/default', {
				cacheFor: 30 * 60 * 1000,
			}),
			colorSchemeId: (screen, defaultColorScheme) => {
				'ngInject';
				return Number(screen.color_scheme_id) || Number(defaultColorScheme.id) || 10001;
			},
			colorScheme: (colorSchemeId, Api) => {
				'ngInject';
				return Api.get('/newsrooms/color_schemes/' + colorSchemeId);
			},
			screenTypes: ApiResourcify.endpoint('/newsrooms/screens/types', {
				cacheFor: 30 * 60 * 1000,
			}),
		},
	});
}

class NewsroomScreenAddeditCtrl {
	constructor(
		Api,
		Identity,
		screen,
		colorScheme,
		colorSchemeId,
		screenTypes,
		elements,
		$state,
		modal,
		$timeout,
		Pubnub,
		notifications
	) {
		'ngInject';
		// save injections
		this.modal = modal;
		this.Api = Api;
		this.notifications = notifications;
		this.Identity = Identity;
		this.$state = $state;
		this.colorSchemeId = colorSchemeId;
		this.screen = screen || {};
		this.elementTypes = elements;
		this.$timeout = $timeout;
		this.Pubnub = Pubnub;
		this.colorScheme = colorScheme;
		this.screenType = (_.find(screenTypes, { type: screen.type }) || {}).name;
		// load options
		this.screen.options = _.extend(this._getDefaultOptions(), this.screen.options || {});
		// default all elements according to the elementType api results
		this.elementTypes.forEach(element => {
			if (element.field in this.screen.options.elements) {
				// something already set
				return;
			}
			// set to the default
			this.screen.options.elements[element.field] = element.default;
		});
		// check how many screens are currently up
		this.checkOccupancy();
	}

	checkOccupancy() {
		this.Pubnub.getOccupancy('newsroom_' + this.screen.code).then(count => {
			this.occupancy = count;
			this.$timeout(() => {});
		});
	}

	selectedHubsChanged() {
		this.screen.options.hubs = this.selectedHubIds.slice(0);
	}

	_patch() {
		let data = {
			name: this.screen.name,
			options: this.screen.options,
			color_scheme_id: Number(this.screen.color_scheme_id) || this.colorSchemeId || 10001,
		};
		return this.Api.patch('/newsrooms/screens/' + this.screen.id, data).then(resp => {
			this.Pubnub.triggerReload('newsroom_' + this.screen.code);
			return resp;
		});
	}

	save() {
		this._patch().then(() => this.goToListing());
	}

	launch() {
		this._patch().then(() => (window.location.href = this.screen.secretUrl));
	}

	goToListing() {
		window.location.href = this.$state.href('hub.loggedin.NewsroomScreenListing');
	}

	_getDefaultOptions() {
		let defaults = {
			// current hub
			hubs: [this.screen.client_id],
			// search
			search: {
				mode: 'mostRecent',
			},
			// videos
			playlist: [],
			// different elements
			elements: {},
			// twitter
			cols: [{ code: '' }, { code: '' }, { code: '' }, { code: '' }],
		};
		return defaults;
	}

	reloadColorScheme() {
		this.Api.get('/newsrooms/color_schemes/' + this.screen.color_scheme_id).then(scheme => (this.colorScheme = scheme));
	}

	customizeColors() {
		let modalOptions = {
			params: {
				selectedSchemeId: this.screen.color_scheme_id,
			},
			heading: 'Choose a color scheme',
			height: 'full',
			width: 470,
		};
		this.modal.state('hub.loggedin.NewsroomColorScheme', modalOptions).then(newSchemeId => {
			if (this.screen.color_scheme_id == newSchemeId) {
				// no change
				return;
			}
			this.screen.color_scheme_id = newSchemeId;
			this.reloadColorScheme();
		});
	}

	parseWidgetCode(evt, idx) {
		this.$timeout(() => {
			var code = evt.target.value;
			// first matching group is the href value; second is the text inside the <a> tags
			var matches = code.match(/<.+href=['"]([^'"]*)[^>]+>([^<]*)<\/a>/);
			if (!matches) {
				// we didn't get a valid twitter embed url
				this.notifications.showError({
					message: 'That Twitter code is not valid. Please try again.',
				});
				return;
			}
			this.screen.options.cols[idx].avatar = '/assets/img/loader-responsive-dark.gif';
			// 1. set headline
			/// get just their @username for the headline
			this.screen.options.cols[idx].headline = matches[2]
				.replace('Tweets by ', '')
				.replace(/Tweets from .+/, 'Tweets from a list');

			// 2. get the href
			var href = matches[1];

			// 3. make sure we have a valid avatar or just get rid of it
			// certain types of widgets don't have corresponding avatars ('/hashtag/', '/lists/')
			if (href.indexOf('hashtag') > -1 || href.indexOf('lists') > -1) {
				delete this.screen.options.cols[idx].avatar;
			} else {
				// if /\/likes$/, get rid of the '/likes' part because that requires logging in
				href = href.replace('/likes', '');
				// go get the image
				this.Api.get('/newsrooms/fetch_twitter_avatar?page=' + encodeURIComponent(href)).then(
					imageUrl => {
						// this happens if the user hasn't changed their profile image
						if (imageUrl.match(/default_profile_images/)) {
							delete this.screen.options.cols[idx].avatar;
							return;
						} else {
							this.screen.options.cols[idx].avatar = imageUrl;
						}
					},
					() => {
						console.error('Failed to fetch twitter avatar.');
					}
				);
			}
		});
	}

	// shouldHave* functions that show the section based on the type of screen
	shouldHaveHubChooser() {
		return ['masonry', 'single', 'video'].indexOf(this.screen.type) > -1;
	}
	shouldHaveCardType() {
		return ['masonry', 'single'].indexOf(this.screen.type) > -1;
	}
	shouldHaveElementTypes() {
		return this.elementTypes.length > 0;
	}
	shouldHaveVideos() {
		return this.screen.type == 'video';
	}
	shouldHaveColumns() {
		return this.screen.type == 'twitter';
	}
	shouldBeStoryMode() {
		return this.screen.options.search.mode === 'story';
	}
}
